<template>
  <div :class="{previews, no_previews: !previews, stack, roundedCorners: rounded}">
    <img @load="setPortraitClass" v-for="(url, index) in preview_urls" :src="url" :key="index"
      v-b-popover.hover.bottom="popoverItem(url)"
    >
  </div>
</template>

<style scoped lang="scss">
@import '~scss/colors';

// TODO: support vertical cards better
.previews img {
  border: 1px solid$gray-1;
  background: white;
  width: 126px;
  margin: 5px;
  &.portrait {
    width: 72px;
  }
}
.previews {
  width: 280px
}
.previews.stack {
  width: 126px
}

.roundedCorners img {
  border-radius: 5px;  // 1/8 inch = 9 pt = 4.5px
}

// When there are no previews, we can simply leave
// the box blank. This can happen if the server doesn't yet
// support previews, or the line was created a while ago, etc
.no_previews {
  width: 20px;
}
</style>

<script>
export default {
  props: {
    preview_urls: Array,
    stack: Boolean,
    rounded: Boolean,
    popover: Boolean
  },
  computed: {
    previews() {
      return this.preview_urls && this.preview_urls.length > 0;
    }
  },
  methods: {
    popoverItem(url) {
      return this.popover && {content: `<img style='width: 504px;' src='${url}'>`, html: true}
    },
    setPortraitClass(evt) {
      // Use dom manipulation to set class
      // If this is an issue, easy enough to switch to using some piece of data
      let img = evt.target;
      img.classList.toggle('portrait', img.naturalWidth < img.naturalHeight);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/LineItemThumbnails.vue